import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCirrusciComponent } from './simple-icons-cirrusci.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCirrusciComponent ],
    exports:      [ SimpleIconsCirrusciComponent ],
    bootstrap:    []
})
export class SimpleIconsCirrusciModule {}
